module.exports = __webpack_public_path__ + "img/borrow-icon.a3735698.png";